import { FC } from 'react';
import { Text, Button } from '@livechat/design-system-react-components';

import { useGetMe } from 'hooks/use-get-me';

import * as styles from './styles';

declare const window: any;

export const HelpCenterFooter: FC = () => {
  const { email, name } = useGetMe();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>): void => {
    e.preventDefault();

    const LC_API = window.LC_API || {};

    if (
      typeof LC_API?.open_chat_window !== 'function' ||
      typeof LC_API?.set_visitor_name !== 'function' ||
      typeof LC_API?.set_visitor_email !== 'function'
    ) {
      return;
    }

    if (name) {
      LC_API.set_visitor_name(name);
    }

    if (email) {
      LC_API.set_visitor_email(email);
    }

    LC_API.open_chat_window();
  };

  return (
    <div css={styles.footer}>
      <Text>Visit&nbsp;</Text>
      <Button
        href="https://www.livechat.com/help/livechat-accounts-a-new-way-to-log-in-to-livechat/"
        target="_blank"
        rel="noopener noreferrer"
        kind="link-light"
      >
        HelpCenter
      </Button>
      <Text>&nbsp;to learn more about organizations, or&nbsp;</Text>
      <Button href="" onClick={handleClick} kind="link-light">
        contact us
      </Button>
      <Text>&nbsp;if you face any problems.</Text>
    </div>
  );
};
